/* eslint-disable @typescript-eslint/no-explicit-any */
import { Config, ErrorHandling, TranslationConfig, EntityDialog } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";
import DOMPurify from "dompurify";
import "./Editors/TinyMCEEditor";
Config.rootNamespaces.push('adminmeem365');
TranslationConfig.getLanguageList = getLanguageList;

// Avoid using `this` in module scope (can be undefined). Attach to window if global access is needed.
(window as any).DOMPurify = DOMPurify;
// Use bound sanitize to preserve context and avoid TS 'possibly undefined' on `this`
gridDefaults.sanitizer = DOMPurify.sanitize.bind(DOMPurify);

let culture = (document.documentElement?.lang || 'en').toLowerCase();
if (flatpickr.l10ns[culture]) {
    flatpickr.localize(flatpickr.l10ns[culture]);
} else {
    culture = culture.split('-')[0];
    flatpickr.l10ns[culture] && flatpickr.localize(flatpickr.l10ns[culture]);
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);


// Globally remove undelete, edit, and localization toolbar buttons from all EntityDialog forms
const origGetToolbarButtons = (EntityDialog as any)?.prototype?.getToolbarButtons;
if (typeof origGetToolbarButtons === 'function') {
    (EntityDialog as any).prototype.getToolbarButtons = function () {
        const buttons: any[] = origGetToolbarButtons.apply(this, arguments) || [];
        return buttons.filter(b => {
            const action = b?.action;
            const cssClass = b?.cssClass || '';
            if (action === 'undo-delete' || cssClass.includes('undo-delete-button') || cssClass.includes('undelete-button')) {
                return false;
            }
            if (action === 'edit' || cssClass.includes('edit-button')) {
                return false;
            }
            if (action === 'localization' || cssClass.includes('localization-button')) {
                return false;
            }
            return true;
        });
    };
}
